function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { useStripe } from '@stripe/react-stripe-js';
import { Formik } from 'formik';
import React, { useContext, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import * as yup from 'yup';
import classNames from 'classnames';
import T from 'prop-types';
import FormFooter from '../../../components/form/FormikFormFooter';
import { MapViewContext } from '../../../components/mapView/mapViewContext';
import { MANUAL_ORDER_MODAL } from '../../../components/modal/ManualOrderModal/ManualOrderModal';
import { PAYMENT_FAILURE_MODAL } from '../../../components/modal/PaymentFailureModal';
import StripeElements from '../../../components/stripe/StripeElements';
import Step from '../../../components/wizard/Step';
import { AMPLITUDE_EVENTS } from '../../../constants/analytics';
import { LEAD_CONFIRMATION_PAGE } from '../../../constants/job';
import { DEFAULT_CURRENCY } from '../../../constants/price';
import { commitJob, commitOrder, refreshCustomer, sendLead, subscribe } from '../../../redux/actions';
import { showModal } from '../../../redux/actions/modal';
import routes from '../../../routes/constants';
import text, { formatCurrency } from '../../../text';
import { amplitudeTrack } from '../../../utilities';
import { client } from '../../../utilities/api';
import { isJobPayable } from '../../../utilities/job';
import { isMembershipPriceId } from '../../../utilities/membership';
import { isStaff, isUserUnderTrial, userHasActiveMembership } from '../../../utilities/user';
import ConfirmationForm from '../ConfirmationForm/Form';
import { ACTIVITY_TYPES } from '../../../constants/activity';
import { captureError } from '../../../utilities/error';
var validationSchema = yup.object({
    terms: yup.bool().oneOf([
        true
    ])
});
var PAYMENT_FLOW = AMPLITUDE_EVENTS.PAYMENT_FLOW;
var ConfirmationStep = function(param) {
    var _param_onSubmit = param.onSubmit, onSubmit = _param_onSubmit === void 0 ? null : _param_onSubmit;
    var jobId = useParams().jobId;
    var stripe = useStripe();
    var dispatch = useDispatch();
    var history = useHistory();
    var returnPage = routes.payment.job(jobId);
    var returnUrl = "".concat(process.env.LARKI_APP_URL).concat(returnPage);
    var _useContext = useContext(MapViewContext), buyNowData = _useContext.state.buyNowData;
    var _useSelector = useSelector(function(state) {
        return {
            membershipPriceId: state.order.membershipPriceId,
            paymentMethodId: state.order.paymentMethodId,
            currentUser: state.profileReducer.userProfile,
            job: state.jobsReducer.job,
            membershipPrices: state.profileReducer.membershipPrices
        };
    }), job = _useSelector.job, paymentMethodId = _useSelector.paymentMethodId, membershipPriceId = _useSelector.membershipPriceId, membershipPrices = _useSelector.membershipPrices, currentUser = _useSelector.currentUser;
    var selectedMembership = useMemo(function() {
        if (membershipPrices.value) {
            return membershipPrices.value.find(function(membership) {
                return membership.id === membershipPriceId;
            });
        }
        return null;
    }, [
        membershipPriceId,
        membershipPrices
    ]);
    var totalPrice = useMemo(function() {
        var membershipTotal = 0;
        var currency = job && job.quote ? _object_spread({}, job.quote.currency) : DEFAULT_CURRENCY;
        if (membershipPriceId && selectedMembership) {
            membershipTotal = selectedMembership.grand_total;
        }
        var jobTotal = jobId ? isMembershipPriceId(membershipPriceId) ? job.quote.price.member_grand_total : job.quote.price.grand_total : 0;
        var dataTotalToPay = isJobPayable(job) ? jobTotal : 0;
        var totalToPay = membershipTotal + dataTotalToPay;
        return totalToPay ? formatCurrency(totalToPay, currency.name, currency.scale_factor, {}, true) : text('toBeConfirmed');
    }, [
        job,
        jobId,
        membershipPriceId,
        selectedMembership
    ]);
    var commit = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(jobToCommit, redirectPath) {
            var membershipSubscribed, order;
            var _arguments = arguments;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        membershipSubscribed = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : null;
                        return [
                            4,
                            dispatch(commitOrder(jobToCommit.id))
                        ];
                    case 1:
                        order = _state.sent();
                        if (!order) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            dispatch(commitJob(jobToCommit.id, membershipSubscribed))
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        if (redirectPath) {
                            history.push(redirectPath);
                        } else {
                            dispatch(showModal(MANUAL_ORDER_MODAL));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function commit(jobToCommit, redirectPath) {
            return _ref.apply(this, arguments);
        };
    }();
    var onPayOrder = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(priceId, paymentMethod, jobToCommit) {
            var membershipResult, membershipIntentSecret, membershipSubscribed, hasMembershipIncluded, _upsertResponse_paymentIntent, _upsertResponse_paymentIntent1, upsertResponse, _upsertResponse_paymentIntent2, _upsertResponse_paymentIntent3, _membershipResult_paymentIntent, _membershipResult_paymentIntent1, _membershipResult_paymentIntent2, _ref, data, _jobToCommit_project, invoice, error, invoiceData, data1, error1, _orderResult_paymentIntent, paymentStatusPath, _ref1, checkoutPaymentIntent, orderResult, error2, isTrial, _membershipResult_paymentIntent3, _orderResult_error_message, error3;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        membershipSubscribed = null;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            30,
                            ,
                            31
                        ]);
                        hasMembershipIncluded = false;
                        if (!(isMembershipPriceId(priceId) && !userHasActiveMembership(currentUser))) return [
                            3,
                            12
                        ];
                        return [
                            4,
                            dispatch(subscribe({
                                user: currentUser,
                                priceId: priceId,
                                paymentMethodId: paymentMethodId,
                                isTrial: false
                            }))
                        ];
                    case 2:
                        upsertResponse = _state.sent();
                        if (!(((_upsertResponse_paymentIntent = upsertResponse.paymentIntent) === null || _upsertResponse_paymentIntent === void 0 ? void 0 : _upsertResponse_paymentIntent.status) === 'succeeded')) return [
                            3,
                            3
                        ];
                        membershipIntentSecret = upsertResponse === null || upsertResponse === void 0 ? void 0 : (_upsertResponse_paymentIntent2 = upsertResponse.paymentIntent) === null || _upsertResponse_paymentIntent2 === void 0 ? void 0 : _upsertResponse_paymentIntent2.client_secret;
                        membershipSubscribed = {
                            name: upsertResponse.name,
                            amount: upsertResponse === null || upsertResponse === void 0 ? void 0 : (_upsertResponse_paymentIntent3 = upsertResponse.paymentIntent) === null || _upsertResponse_paymentIntent3 === void 0 ? void 0 : _upsertResponse_paymentIntent3.amount
                        };
                        return [
                            3,
                            12
                        ];
                    case 3:
                        if (!(((_upsertResponse_paymentIntent1 = upsertResponse.paymentIntent) === null || _upsertResponse_paymentIntent1 === void 0 ? void 0 : _upsertResponse_paymentIntent1.status) === 'requires_confirmation')) return [
                            3,
                            12
                        ];
                        return [
                            4,
                            stripe.confirmCardPayment(upsertResponse.payment_intent_secret, {
                                payment_method: paymentMethod,
                                return_url: returnUrl
                            }, {
                                handleActions: false
                            })
                        ];
                    case 4:
                        membershipResult = _state.sent();
                        if (!((membershipResult === null || membershipResult === void 0 ? void 0 : (_membershipResult_paymentIntent = membershipResult.paymentIntent) === null || _membershipResult_paymentIntent === void 0 ? void 0 : _membershipResult_paymentIntent.status) === 'succeeded')) return [
                            3,
                            11
                        ];
                        hasMembershipIncluded = true;
                        _state.label = 5;
                    case 5:
                        _state.trys.push([
                            5,
                            9,
                            ,
                            10
                        ]);
                        return [
                            4,
                            client.getInvoiceBySubscriptionId(upsertResponse === null || upsertResponse === void 0 ? void 0 : upsertResponse.id)
                        ];
                    case 6:
                        _ref = _state.sent(), data = _ref.data.data;
                        if (!(data.length > 0)) return [
                            3,
                            8
                        ];
                        invoice = data[0];
                        if (!(invoice.status === 'paid' && (jobToCommit === null || jobToCommit === void 0 ? void 0 : (_jobToCommit_project = jobToCommit.project) === null || _jobToCommit_project === void 0 ? void 0 : _jobToCommit_project.id))) return [
                            3,
                            8
                        ];
                        return [
                            4,
                            client.createActivity(jobToCommit.project.id, {
                                type: ACTIVITY_TYPES.order,
                                title: text('invoice'),
                                description: 'Membership invoice paid',
                                metadata: {
                                    action: 'invoice',
                                    type: 'membership',
                                    receipt_url: invoice.hosted_invoice_url
                                },
                                jobId: jobToCommit.id
                            })
                        ];
                    case 7:
                        _state.sent();
                        _state.label = 8;
                    case 8:
                        return [
                            3,
                            10
                        ];
                    case 9:
                        error = _state.sent();
                        console.error('Error fetching invoice', error);
                        captureError(error);
                        return [
                            3,
                            10
                        ];
                    case 10:
                        membershipIntentSecret = membershipResult === null || membershipResult === void 0 ? void 0 : (_membershipResult_paymentIntent1 = membershipResult.paymentIntent) === null || _membershipResult_paymentIntent1 === void 0 ? void 0 : _membershipResult_paymentIntent1.client_secret;
                        membershipSubscribed = {
                            name: upsertResponse.name,
                            amount: membershipResult === null || membershipResult === void 0 ? void 0 : (_membershipResult_paymentIntent2 = membershipResult.paymentIntent) === null || _membershipResult_paymentIntent2 === void 0 ? void 0 : _membershipResult_paymentIntent2.amount
                        };
                        _state.label = 11;
                    case 11:
                        if (membershipResult === null || membershipResult === void 0 ? void 0 : membershipResult.error) {
                            membershipSubscribed = null;
                            dispatch(showModal(PAYMENT_FAILURE_MODAL, {
                                message: text('membershipPaymentFailed')
                            }));
                        }
                        _state.label = 12;
                    case 12:
                        if (!isMembershipPriceId(priceId)) return [
                            3,
                            14
                        ];
                        return [
                            4,
                            dispatch(refreshCustomer())
                        ];
                    case 13:
                        _state.sent();
                        _state.label = 14;
                    case 14:
                        _state.trys.push([
                            14,
                            16,
                            ,
                            17
                        ]);
                        return [
                            4,
                            client.generateInvoice(jobId, currentUser.email, currentUser.full_name, text('invoiceGenerationMessage'), false, false)
                        ];
                    case 15:
                        data1 = _state.sent().data;
                        invoiceData = data1;
                        return [
                            3,
                            17
                        ];
                    case 16:
                        error1 = _state.sent();
                        console.error('Error generating invoice:', error1);
                        captureError(error1, {
                            jobId: jobId,
                            currentUser: currentUser
                        });
                        return [
                            3,
                            17
                        ];
                    case 17:
                        if (!(buyNowData.length > 0)) return [
                            3,
                            27
                        ];
                        return [
                            4,
                            client.checkout(jobId, {
                                orderHasMembershipIncluded: hasMembershipIncluded
                            })
                        ];
                    case 18:
                        _ref1 = _state.sent(), checkoutPaymentIntent = _ref1.data;
                        return [
                            4,
                            stripe.confirmCardPayment(checkoutPaymentIntent, {
                                payment_method: paymentMethod,
                                return_url: returnUrl
                            }, {
                                handleActions: false
                            })
                        ];
                    case 19:
                        orderResult = _state.sent();
                        if (!((orderResult === null || orderResult === void 0 ? void 0 : (_orderResult_paymentIntent = orderResult.paymentIntent) === null || _orderResult_paymentIntent === void 0 ? void 0 : _orderResult_paymentIntent.status) === 'succeeded')) return [
                            3,
                            26
                        ];
                        if (!(invoiceData && invoiceData.id)) return [
                            3,
                            24
                        ];
                        _state.label = 20;
                    case 20:
                        _state.trys.push([
                            20,
                            23,
                            ,
                            24
                        ]);
                        return [
                            4,
                            client.payInvoice(invoiceData.id, {
                                payment_intent: orderResult.paymentIntent.id
                            })
                        ];
                    case 21:
                        _state.sent();
                        return [
                            4,
                            client.createActivity(jobToCommit.project.id, {
                                type: ACTIVITY_TYPES.order,
                                title: text('invoice'),
                                description: 'Order invoice paid',
                                metadata: {
                                    action: 'invoice',
                                    type: 'order',
                                    receipt_url: invoiceData.hosted_invoice_url
                                },
                                jobId: jobToCommit.id
                            })
                        ];
                    case 22:
                        _state.sent();
                        return [
                            3,
                            24
                        ];
                    case 23:
                        error2 = _state.sent();
                        console.error('Error updating invoice to status paid:', error2);
                        captureError(error2);
                        return [
                            3,
                            24
                        ];
                    case 24:
                        paymentStatusPath = "".concat(routes.payment.status(jobId), "?orderClientSecret=").concat(orderResult.paymentIntent.client_secret);
                        if (membershipIntentSecret) {
                            paymentStatusPath = paymentStatusPath.concat("&membershipClientSecret=".concat(membershipIntentSecret));
                        }
                        isTrial = isUserUnderTrial(currentUser);
                        if (isTrial) {
                            paymentStatusPath = paymentStatusPath.concat("&isTrial=true");
                        }
                        amplitudeTrack(PAYMENT_FLOW.EVENT, {
                            action: PAYMENT_FLOW.PAID
                        });
                        return [
                            4,
                            commit(jobToCommit, paymentStatusPath, membershipSubscribed)
                        ];
                    case 25:
                        _state.sent();
                        _state.label = 26;
                    case 26:
                        if (orderResult.error) {
                            ;
                            ;
                            dispatch(showModal(PAYMENT_FAILURE_MODAL, {
                                message: (membershipResult === null || membershipResult === void 0 ? void 0 : (_membershipResult_paymentIntent3 = membershipResult.paymentIntent) === null || _membershipResult_paymentIntent3 === void 0 ? void 0 : _membershipResult_paymentIntent3.status) === 'succeeded' ? text('membershipSuccessButOrderFailed') : (_orderResult_error_message = orderResult.error.message) !== null && _orderResult_error_message !== void 0 ? _orderResult_error_message : text('paymentFailed')
                            }));
                        }
                        return [
                            3,
                            29
                        ];
                    case 27:
                        return [
                            4,
                            commit(jobToCommit, null, membershipSubscribed)
                        ];
                    case 28:
                        _state.sent();
                        _state.label = 29;
                    case 29:
                        return [
                            3,
                            31
                        ];
                    case 30:
                        error3 = _state.sent();
                        console.error('Error in payment process:', error3);
                        dispatch(showModal(PAYMENT_FAILURE_MODAL, {
                            message: error3.message || text('paymentFailed')
                        }));
                        return [
                            3,
                            31
                        ];
                    case 31:
                        return [
                            2
                        ];
                }
            });
        });
        return function onPayOrder(priceId, paymentMethod, jobToCommit) {
            return _ref.apply(this, arguments);
        };
    }();
    useEffect(function() {
        if (jobId) {
            dispatch(sendLead(jobId, LEAD_CONFIRMATION_PAGE));
        }
    }, [
        dispatch,
        jobId
    ]);
    return /*#__PURE__*/ React.createElement(Formik, {
        initialValues: {
            terms: false
        },
        validationSchema: validationSchema,
        onSubmit: function() {
            if (onSubmit) {
                onSubmit();
            } else {
                var handlePayment = function() {
                    if (isStaff(currentUser.role)) {
                        commit(job);
                    } else {
                        onPayOrder(membershipPriceId, paymentMethodId, job);
                    }
                };
                handlePayment();
            }
        },
        validateOnMount: true
    }, function(param) {
        var isValid = param.isValid;
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Step, null, /*#__PURE__*/ React.createElement(ConfirmationForm, null)), /*#__PURE__*/ React.createElement(FormFooter, {
            label: /*#__PURE__*/ React.createElement("span", {
                style: {
                    fontSize: 16
                },
                className: classNames({
                    'green-1': !isValid
                })
            }, totalPrice, " -", ' ', text(isStaff(currentUser.role) ? 'commitOrder' : isJobPayable(job) || isMembershipPriceId(membershipPriceId) ? 'payNow' : 'order')),
            disabled: !isValid
        }));
    });
};
ConfirmationStep.propTypes = {
    onSubmit: T.func
};
var ConfirmationStepWithStripe = function(props) {
    return /*#__PURE__*/ React.createElement(StripeElements, null, /*#__PURE__*/ React.createElement(ConfirmationStep, props));
};
export default ConfirmationStepWithStripe;
